import React from "react";
import glamorous, { Div } from "glamorous";
import { css } from "glamor";
import { dimensions } from "../../style/index";

const addGradient = gradient => {
  if (gradient) {
    return { background: gradient };
  }
};

const addBackgroundColor = color => {
  if (color) {
    return { background: color };
  }
};

const addBackgroundImage = image => {
  if (image) {
    return {
      background: `linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${image})`,
      backgroundPosition: "center"
    };
  }
};

const SectionContainer = glamorous.div(
  {
    minHeight: 660
  },
  ({ backgroundColor, gradient }) => ({
    ...addBackgroundColor(backgroundColor),
    ...addGradient(gradient)
  })
);

const sectionStyle = (backgroundImage, backgroundColor, gradient, height) =>
  css({
    minHeight: height ? height : 660,
    ...addBackgroundImage(backgroundImage),
    ...addBackgroundColor(backgroundColor),
    ...addGradient(gradient)
  });

const Title = glamorous.span({
  fontFamily: "'Playfair Display', serif",
  fontSize: 32,
  color: "white",
  zIndex: 2,
  textTransform: "uppercase"
});

const TitleContainer = glamorous.div({
  textAlign: "center",
  paddingTop: 106,
  [dimensions.SCREEN_MAX_LG]: {
    paddingTop: 53
  }
});

const renderTitle = (title, titleStyles) => {
  if (title) {
    return (
      <TitleContainer {...titleStyles}>
        <Title>{title}</Title>
      </TitleContainer>
    );
  }
};
const SearchSection = props => {
  const {
    backgroundImage,
    backgroundColor,
    gradient,
    title,
    height,
    otherStyles,
    titleStyles
  } = props;

  return (
    <Div
      position="relative"
      paddingBottom={40}
      {...sectionStyle(backgroundImage, backgroundColor, gradient, height)}
      {...otherStyles}
    >
      {renderTitle(title, titleStyles)}
      {props.children}
    </Div>
  );
};

export default SearchSection;



// WEBPACK FOOTER //
// ./src/components/blocks/SearchSection.jsx